import { createContext } from 'react';
import { JaSouClienteContext as JaSouClienteContextInterface } from '../types/JornadaJaSouCliente/JaSouClienteContext';

const JaSouClienteContext = createContext<JaSouClienteContextInterface | undefined>(undefined);

export default JaSouClienteContext;
